import * as render from './render.js';
import global from './global.js';
import { Player } from './player.js';
import { Food } from './food.js';
import { Virus } from './virus.js';
import { SaasBlob } from './saasBlob.js';
import config from './config.js';
import Canvas from './canvas.js';
import { parseGif, decompressGifFrames } from './gifuct-wrapper.js';
const twitterLogo = new URL('../assets/images/logo-black.png', import.meta.url).href;
import runConfetti from './confetti-wrapper.js';
import { Powerup } from './powerup.js';

// Add this line to destructure the renderGame function from the render module
const { renderGame } = render;

// let player = null;
let gameState = null;

const logoCache = {};

var playerNameInput = document.getElementById('playerNameInput');

// Add this near the top of the file with other global variables
global.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

global.virusGif = new Image();
global.virusGif.src = '../assets/images/thunderstorm.gif';

global.virusGif.onload = function() {
};

global.virusGif.onerror = function(e) {
};

// At the top of the file, after other imports
// import { parseGIF, decompressFrames } from 'gifuct-js';

// Add this code after other global initializations
global.virusGifElement = document.getElementById('virusGif');
global.virusGifCanvas = document.createElement('canvas');
global.virusGifCtx = global.virusGifCanvas.getContext('2d');
global.virusGifFrames = [];
global.virusGifCurrentFrame = 0;
global.virusGifLoaded = false;

if (global.virusGifElement) {
    global.virusGifElement.onload = function() {
        fetch(this.src)
            .then(resp => resp.arrayBuffer())
            .then(buff => parseGIF(buff))
            .then(gif => {
                global.virusGifFrames = decompressGifFrames(gif, true);
                if (global.virusGifFrames.length > 0) {
                    global.virusGifCanvas.width = global.virusGifFrames[0].dims.width;
                    global.virusGifCanvas.height = global.virusGifFrames[0].dims.height;
                    global.virusGifLoaded = true;
                } else {
                    console.warn('No frames found in the GIF');
                }
            })
            .catch(error => {
                console.error('Error processing Virus GIF:', error);
            });
    };
}

global.virusGifElement.onerror = function(e) {
    console.error('Failed to load Virus GIF', e);
};


// Add this function to update the GIF frame
function updateVirusGif() {
    if (!global.virusGifLoaded || global.virusGifFrames.length === 0) return;
    
    global.virusGifCurrentFrame = (global.virusGifCurrentFrame + 1) % global.virusGifFrames.length;
    const frame = global.virusGifFrames[global.virusGifCurrentFrame];
    
    global.virusGifCtx.clearRect(0, 0, global.virusGifCanvas.width, global.virusGifCanvas.height);
    
    if (frame && frame.patch) {
        try {
            if (frame.patch instanceof ImageData) {
                global.virusGifCtx.putImageData(frame.patch, frame.dims.left, frame.dims.top);
            } else if (frame.patch instanceof Uint8ClampedArray) {
                const imageData = new ImageData(frame.patch, frame.dims.width, frame.dims.height);
                global.virusGifCtx.putImageData(imageData, frame.dims.left, frame.dims.top);
            } else {
                console.warn('Unexpected frame patch type:', typeof frame.patch);
            }
        } catch (error) {
            console.error('Error rendering GIF frame:', error);
        }
    } else {
        console.warn('Invalid frame data:', frame);
    }
}

// Call this function in your game loop or use setInterval
setInterval(updateVirusGif, 50); // Update every 50ms, adjust as needed


var debug = function (args) {
    if (console && console.log) {
        console.log(args);
    }
};

function preloadLogos(saasBlobs) {
    saasBlobs.forEach(blob => {
        if (blob.saasInfo && blob.saasInfo.logourl && !logoCache[blob.saasInfo.logourl]) {
            const img = new Image();
            img.src = blob.saasInfo.logourl;
            logoCache[blob.saasInfo.logourl] = img;
        }
    });
}

// Update drawSaasBlob function
function drawSaasBlob(position, saasBlob, graph) {
    if (!saasBlob || !saasBlob.saasInfo) {
        console.error('Invalid saasBlob:', saasBlob);
        return;
    }

    const logoUrl = `assets/images/logos/${saasBlob.saasInfo.saasname.replace(/\s+/g, '').toLowerCase()}.png`;
    const img = new Image();
    img.src = logoUrl;
    img.onload = () => {
        const size = saasBlob.radius * 2;
        graph.drawImage(img, position.x - saasBlob.radius, position.y - saasBlob.radius, size, size);
    };
    img.onerror = () => {
        fallbackDraw(position, saasBlob, graph);
    };
}

function fallbackDraw(position, saasBlob, graph) {
    graph.fillStyle = saasBlob.fill || '#FF69B4';
    graph.beginPath();
    graph.arc(position.x, position.y, saasBlob.radius, 0, 2 * Math.PI);
    graph.fill();
}

// Add this near the top of the file with other global variables
let collectedSaas = [];


let gameStarted = false;

// Add this near the top of the file with other global variables
let lastCollidedSaas = null;

function startGame() {
    if (gameStarted) {
        return;
    }
    global.playerName = playerNameInput.value.replace(/(<([^>]+)>)/ig, '').substring(0, 25);

    // Initialize your game here
    const canvas = document.getElementById('cvs');
    const ctx = canvas.getContext('2d');
    global.ctx = ctx;

    canvas.width = global.screen.width;
    canvas.height = global.screen.height;

    player = new Player(1, global.playerName, Math.random() * config.gameWidth, Math.random() * config.gameHeight);
    player.level = 1;
    player.gameStartTime = Date.now();

    global.player = player;
    gameState = {
        players: [player],
        food: [],
        viruses: [],
        saasBlobs: [],
        powerups: []
    };

    global.game = {
        width: config.gameWidth,
        height: config.gameHeight
    };

    initializeGameObjects();
    setupEventListeners();
    global.gameStart = true;
    window.canvas = new Canvas();
    initializeClouds();
    initializeLevel(player.level); 
    gameLoop();
    gameStarted = true;

    console.log("Starting game with level:", player.level);
}



function initializeGameObjects() {
    // Initialize food
    for (let i = 0; i < config.maxFood; i++) {
        gameState.food.push(new Food());
    }

    // Initialize viruses
    for (let i = 0; i < config.maxVirus; i++) {
        gameState.viruses.push(new Virus());
    }

    // Initialize SaaS blobs
    saasInfoCollection.forEach(saasInfo => {
        const x = Math.random() * config.gameWidth;
        const y = Math.random() * config.gameHeight;
        gameState.saasBlobs.push(new SaasBlob(saasInfo, x, y));
    });
}

function setupEventListeners() {
    document.addEventListener('mousemove', (event) => {
        global.target.x = event.clientX;
        global.target.y = event.clientY;
    });

    // document.addEventListener('keydown', (event) => {
    //     if (event.code === 'Space') {
    //         player.split();
    //     }
    // });
}

function validNick() {
    var regex = /^\w*$/;
    debug('Regex Test', regex.exec(playerNameInput.value));
    return regex.exec(playerNameInput.value) !== null;
}

function updatePlayerPosition() {
    if (global.target && (global.target.x !== 0 || global.target.y !== 0)) {
        let dx, dy;
        
        if (global.isMobile) {
            // For mobile devices
            dx = global.target.x;
            dy = global.target.y;
        } else {
            if ((global.target.x >= 0 && global.target.x <= global.screen.width &&
                               global.target.y >= 0 && global.target.y <= global.screen.height)) {
                dx = global.target.x - global.screen.width / 2;
                dy = global.target.y - global.screen.height / 2;
            } else {
                return; // Don't update position if mouse is off-screen and continuity is off
            }
        }
        
        const distance = Math.sqrt(dx * dx + dy * dy);
        
        if (distance > 1) {  // Only move if the distance is significant
            const baseSpeed = 2.4;
            const maxSpeed = 3.6;
            
            // Calculate actual speed considering speedBoost and slowEffect
            const actualSpeed = Math.min(baseSpeed * player.speedBoost * player.slowEffect, maxSpeed);
            
            const moveX = (dx / distance) * actualSpeed;
            const moveY = (dy / distance) * actualSpeed;
            
            // Update player position
            player.x += moveX;
            player.y += moveY;
            
            // Keep the player within game boundaries
            player.x = Math.max(0, Math.min(player.x, config.gameWidth));
            player.y = Math.max(0, Math.min(player.y, config.gameHeight));
            
            player.updatePosition(player.x, player.y);
            
            // Update the camera position
            if (global.isMobile) {
                updateMobileCamera();
            } else {
                // Keep desktop camera behavior unchanged
                global.camera.x = player.x;
                global.camera.y = player.y;
            }
        }
    }
}

// // Add this new function for mobile camera update
export function updateMobileCamera() {
    const padding = 100; // Padding around the player
    const playerDiameter = player.radius * 2;
    const screenWidth = global.screen.width;
    const screenHeight = global.screen.height;
    
    // Calculate zoom based on both width and height
    const zoomX = screenWidth / (playerDiameter + padding * 2);
    const zoomY = screenHeight / (playerDiameter + padding * 2);
    
    // Use the smaller zoom to ensure the player fits in both dimensions
    let zoom = Math.min(zoomX, zoomY);
    
    // Set a minimum zoom level to prevent excessive zooming in
    const minZoom = 0.5; // Adjust this value as needed
    zoom = Math.min(zoom, minZoom);
    
    // Smoothly interpolate the zoom
    global.camera.zoom += (zoom - global.camera.zoom) * 0.1;
    
    // Update the camera position
    global.camera.x = player.x;
    global.camera.y = player.y;
}


function checkCollisions() {
    const playerRadius = player.radius;

    for (let i = 0; i < gameState.food.length; i++) {
        const food = gameState.food[i];
        const dx = player.x - food.x;
        const dy = player.y - food.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        // Require a greater overlap before consuming the food cloud
        // Now the player needs to cover about 75% of the food cloud's diameter
        if (distance + food.radius * 0.75 <= playerRadius) {
            player.eatFood(food);
            gameState.food.splice(i, 1);
            updateScore();
            i--;
        }
    }

    for (let i = 0; i < gameState.viruses.length; i++) {
        const virus = gameState.viruses[i];
        if (player.checkCollision(virus)) {
            player.handleVirusCollision(virus);
        }
    }

    for (let i = 0; i < gameState.saasBlobs.length; i++) {
        const saasBlob = gameState.saasBlobs[i];
        const collisionResult = player.checkCollision(saasBlob);
        if (collisionResult === true) {
            console.log("SaasBlob collected");
            gameState.saasBlobs.splice(i, 1);
            updateScore();
            if (saasBlob.saasInfo) {
                showSaasPopup(saasBlob.saasInfo);
                collectedSaas.push(saasBlob.saasInfo.saasname);
                updateCollectedSaas();
            }
            i--;
            if (global.isMobile) {
                console.log("Calling updateMobileCamera after SaasBlob collision");
                updateMobileCamera();
            }
        } else if (collisionResult === 'gameOver') {
            lastCollidedSaas = saasBlob.saasInfo;
            return 'gameOver';
        }
    }

    player.mergeCells();

    const blobsRequired = player.level === 1 ? 3 : player.level === 2 ? 5 : 7;
    if (collectedSaas.length >= blobsRequired) {
        return 'levelComplete';
    }

    return null;
}

function progressToNextLevel() {
    player.level++;
    if (player.level > 3) {
        gameCompleted();
    } else {
        // Clear collected SaaS for the new level
        player.collectedSaas = [];
        collectedSaas = [];
        updateCollectedSaas();
        initializeLevel(player.level);
        
        // Show level objective
        const blobsToCollect = config.levelObjectives[player.level - 1];
        showLevelObjective(player.level, blobsToCollect);
    }
}

function initializeLevel(level) {
    console.log("Initializing level:", level);
    player.x = Math.random() * config.gameWidth;
    player.y = Math.random() * config.gameHeight;
    player.radius = Math.sqrt(100 / Math.PI) * 10; // Reset to default size
    player.mass = 100; // Reset mass
    
    // Keep the current score
    const currentScore = player.score;
    
    // Reset other player properties
    player.cells = [player];
    player.maxCells = 16;
    player.speedBoost = 1;
    player.slowEffect = 1;
    
    // Reassign the kept score
    player.score = currentScore;
    
    gameState.saasBlobs = [];
    const blobsToCollect = config.levelObjectives[level - 1];
    const totalBlobs = blobsToCollect * 2; // Double the number of blobs to collect
    console.log("Blobs to collect:", blobsToCollect);
    console.log("Total blobs in level:", totalBlobs);

    // Create a copy of saasInfoCollection to work with
    const availableSaasInfo = [...saasInfoCollection];

    for (let i = 0; i < totalBlobs; i++) {
        if (availableSaasInfo.length === 0) {
            // If we run out of unique SaaS, start over with the full collection
            availableSaasInfo.push(...saasInfoCollection);
        }
        const randomIndex = Math.floor(Math.random() * availableSaasInfo.length);
        const saasInfo = availableSaasInfo.splice(randomIndex, 1)[0];
        const x = Math.random() * config.gameWidth;
        const y = Math.random() * config.gameHeight;
        gameState.saasBlobs.push(new SaasBlob(saasInfo, x, y, level));
    }

    updateLevelInfo();
    showLevelObjective(level, blobsToCollect);
}

function showLevelObjective(level, blobsToCollect) {
    console.log("Showing objective for level:", level, "Products to collect:", blobsToCollect);
    const objectivePopup = document.createElement('div');
    objectivePopup.textContent = `Level ${level}: Collect ${blobsToCollect} SaaS Products`;
    objectivePopup.style.cssText = `
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(0, 0, 0, 0.7);
        color: white;
        padding: 10px 20px;
        border-radius: 5px;
        font-size: 18px;
        z-index: 1000;
    `;

    // Position the popup lower on mobile devices
    if (global.isMobile) {
        objectivePopup.style.top = '30%';
    } else {
        objectivePopup.style.top = '10px';
    }

    document.body.appendChild(objectivePopup);
    setTimeout(() => {
        objectivePopup.style.opacity = '0';
        objectivePopup.style.transition = 'opacity 1s ease-out';
        setTimeout(() => objectivePopup.remove(), 1000);
    }, 5000);
}

// Add this function to initialize clouds
function initializeClouds() {
    global.clouds = render.createClouds(global.game.width, global.game.height, 15); // Reduced count from 25 to 15
}

// Call this function when initializing your game
initializeClouds();

function updateGameState(deltaTime) {
    updatePlayerPosition();
    const collisionResult = checkCollisions();
    if (collisionResult === 'gameOver') {
        handleGameOver();
        return;
    }
    if (collisionResult === 'levelComplete') {
        progressToNextLevel();
        return;
    }
    balanceObjects();
    player.mergeCells();
    updateSaasBlobs();
    spawnPowerup();
    checkPowerupCollisions();
    render.renderGame(gameState, player, global.ctx);
    updateScore();
    updateLevelInfo();
    updateTimer();
}

function updateSaasBlobs() {
    gameState.saasBlobs.forEach(blob => {
        blob.update(player);
    });
}

function handleGameOver() {
    global.gameStart = false;
    const gameOverMessage = document.createElement('div');
    gameOverMessage.id = 'gameOverMessage';
    gameOverMessage.style.position = 'absolute';
    gameOverMessage.style.top = '50%';
    gameOverMessage.style.left = '50%';
    gameOverMessage.style.transform = 'translate(-50%, -50%)';
    gameOverMessage.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
    gameOverMessage.style.color = 'white';
    gameOverMessage.style.padding = global.isMobile ? '20px' : '30px';
    gameOverMessage.style.borderRadius = '10px';
    gameOverMessage.style.zIndex = '2000';
    gameOverMessage.style.textAlign = 'center';

    let saasInfo = lastCollidedSaas ? lastCollidedSaas : { saasname: 'Unknown SaaS', description: 'No description available.' };

    gameOverMessage.innerHTML = `
        <h2>Game Over</h2>
        <p>You have been beaten by: ${saasInfo.saasname}</p>
        <p style="margin-top: 20px; font-style: italic;">${saasInfo.description}</p>
        ${saasInfo.websiteurl ? `
            <a href="${saasInfo.websiteurl}" target="_blank" style="
                display: inline-block;
                margin-top: 20px;
                padding: 10px 20px;
                background-color: #4CAF50;
                color: white;
                text-decoration: none;
                border-radius: 5px;
                font-size: 16px;
            ">Check out ${saasInfo.saasname}</a>
        ` : ''}
        <button onclick="window.location.reload();" style="
            display: block;
            margin: 20px auto 0;
            padding: 10px 20px;
            background-color: #f44336;
            color: white;
            border: none;
            border-radius: 5px;
            font-size: 16px;
            cursor: pointer;
        ">Play Again</button>
    `;

    document.body.appendChild(gameOverMessage);
}

let lastTime = 0;
function gameLoop(currentTime) {
    if (!lastTime) lastTime = currentTime;
    const deltaTime = (currentTime - lastTime) / 1000;
    lastTime = currentTime;

    if (global.gameStart && player.score < player.maxScore) {
        updatePlayerPosition();
        updateGameState(deltaTime);
        if (global.isMobile) updateMobileCamera(); // Add this line
        render.renderGame(gameState, player, global.ctx);
        updateScore();
        updateLevelInfo();
        updateTimer();
        global.canvas.drawTouchController(global.ctx);
        requestAnimationFrame(gameLoop);
    } else if (player.score >= player.maxScore) {
        gameCompleted();
    }
}


window.addEventListener('resize', resize);

function resize() {
    if (!player) return;

    global.screen.width = window.innerWidth;
    global.screen.height = window.innerHeight;

    // Update canvas size
    const canvas = document.getElementById('cvs');
    canvas.width = global.screen.width;
    canvas.height = global.screen.height;

    // Update player's screen dimensions
    player.screenWidth = global.screen.width;
    player.screenHeight = global.screen.height;

    // Recreate clouds when resizing
    initializeClouds();

    // Adjust game boundaries if needed
    if (global.game) {
        global.game.width = Math.max(global.screen.width, config.gameWidth);
        global.game.height = Math.max(global.screen.height, config.gameHeight);
    }


    // Center the player if they're outside the game boundaries
    player.x = Math.min(Math.max(player.x, global.screen.width / 2), global.game.width - global.screen.width / 2);
    player.y = Math.min(Math.max(player.y, global.screen.height / 2), global.game.height - global.screen.height / 2);

    // Redraw the game
    if (global.gameStart) {
        render.renderGame(gameState, player, global.ctx);
    }
}

let currentPopup = null;

// Add this function near the top of your app.js file, after the imports
function getLogoUrl(saasName) {
    const formattedName = saasName.replace(/\s+/g, '').toLowerCase();
    const pngLogoUrl = `assets/images/logos/${formattedName}.png`;
    const svgLogoUrl = `assets/images/logos/${formattedName}.svg`;
    return [pngLogoUrl, svgLogoUrl];
}

// Update the showSaasPopup function to use the getLogoUrl function
async function showSaasPopup(saas) {
    const popup = document.createElement('div');
    popup.className = 'saas-popup';
    popup.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: white;
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0 0 10px rgba(0,0,0,0.5);
        z-index: 1000;
        max-width: 80%;
        width: ${global.isMobile ? '90%' : '300px'};
        box-sizing: border-box;
    `;

    const saasName = saas.saasname || 'Unknown SaaS';
    const description = saas.description || 'No description available';
    const websiteUrl = saas.websiteurl || '#';
    const [pngLogoUrl, svgLogoUrl] = getLogoUrl(saasName);

    // Define X logo HTML
    const xLogoHTML = saas.x ? 
        `<a href="${saas.x}" target="_blank" rel="noopener noreferrer" style="margin-left: 5px; margin-top:2px; text-decoration: none;">
            <img src="assets/images/logo-black.png" alt="X (Twitter) Logo" style="width: 16px; height: 16px; vertical-align: middle;">
         </a>` : 
        '';

    // Define discountHTML with improved styling
    const discountHTML = saas.discount ? 
        `<div style="
            background-color: #4CAF50;
            color: white;
            padding: 10px;
            border-radius: 5px;
            margin-top: 10px;
            font-weight: bold;
            text-align: center;
        ">
            ${saas.discount} off with code <span style="background-color: white; color: #4CAF50; padding: 2px 5px; border-radius: 3px;">${saas.discountcode}</span>
        </div>` : 
        '';

    popup.innerHTML = `
        <div class="popup-content">
            <div class="popup-header" style="display: flex; align-items: center; margin-bottom: 15px;">
                <img src="${svgLogoUrl}" alt="${saasName} logo" class="popup-logo" onerror="this.onerror=null; this.src='${pngLogoUrl}';" style="width: 40px; height: 40px; margin-right: 10px;">
                <div>
                    <h2 style="margin: 0; font-size: 20px;">${saasName}</h2>
                    <p class="saas-author" style="margin: 5px 0 0; font-size: 14px; color: #666;">
                        By: ${saas.name || 'Unknown'}${xLogoHTML}
                    </p>
                </div>
            </div>
            <p class="saas-description" style="font-size: 14px; line-height: 1.4;">${description}</p>
            ${discountHTML}
            
            ${websiteUrl !== '#' ? 
                `<a href="${websiteUrl}" target="_blank" rel="noopener noreferrer" class="cta-button" style="display: block; background-color: #4784FA; color: white; text-align: center; padding: 10px; text-decoration: none; border-radius: 5px; margin-top: 20px; font-weight: bold;">Check out ${saasName}</a>` :
                `<p>Website URL not available</p>`
            }
            <button class="close-popup" style="position: absolute; top: 10px; right: 10px; background: none; border: none; font-size: 25px; cursor: pointer; color: #666;">&times;</button>
        </div>
    `;

    if (global.isMobile) {
        popup.style.margin = '0 auto';
        popup.style.left = '0';
        popup.style.right = '0';
        popup.style.transform = 'translateY(-50%)';
    }

    document.body.appendChild(popup);
    currentPopup = popup;

    // Add event listener for the close button
    popup.querySelector('.close-popup').addEventListener('click', () => {
        fadeOutAndRemovePopup(popup);
    });

    if (saas.discount) {
        // Trigger custom confetti effect
        try {
            await runConfetti({
                particleCount: 100,
                spread: 70,
                origin: { y: 0.6 },
                shapes: ['circle', 'square'],
                colors: ['#FFD700', '#FFA500', '#FF4500'] // Gold, Orange, Red
            });
        } catch (error) {
            console.error('Failed to run confetti:', error);
        }

        // For popups with discounts, set the timeout to 5 seconds
        setTimeout(() => {
            fadeOutAndRemovePopup(popup);
        }, 3000);
    } else {
        // For popups without discounts, keep the 3-second timeout
        setTimeout(() => {
            fadeOutAndRemovePopup(popup);
        }, 3000);
    }
}

function fadeOutAndRemovePopup(popup) {
    popup.style.transition = 'opacity 0.5s ease-out';
    popup.style.opacity = '0';
    setTimeout(() => {
        if (popup.parentNode) {
            popup.parentNode.removeChild(popup);
        }
    }, 500);
}

document.addEventListener('DOMContentLoaded', function() {
    const backgroundImage =  '../assets/images/background9.png';

    global.backgroundImage = new Image();
    global.backgroundImage.crossOrigin = "Anonymous";
    global.backgroundImage.src = backgroundImage;

    global.backgroundImage.onload = function() {
        // Call a function to draw the background here
        drawBackground();
    };
    global.backgroundImage.onerror = function(e) {
        console.error('Error loading background image:', e);
        console.error('Image source:', this.src);
    };

    var btn = document.getElementById('startButton'),
        // btnS = document.getElementById('spectateButton'),
        nickErrorText = document.querySelector('#startMenu .input-error');

    // btnS.onclick = function () {
    //     startGame('spectator');
    // };

    btn.onclick = function () {

        // Checks if the nick is valid.
        if (validNick()) {
            nickErrorText.style.opacity = 0;
            startGame('player');
        } else {
            nickErrorText.style.opacity = 1;
        }
    };

    // var settingsMenu = document.getElementById('settingsButton');
    // var settings = document.getElementById('settings');

    // settingsMenu.onclick = function () {
    //     if (settings.style.maxHeight == '300px') {
    //         settings.style.maxHeight = '0px';
    //     } else {
    //         settings.style.maxHeight = '300px';
    //     }
    // };

    playerNameInput.addEventListener('keypress', function (e) {
        var key = e.which || e.keyCode;

        if (key === global.KEY_ENTER) {
            if (validNick()) {
                nickErrorText.style.opacity = 0;
                startGame('player');
            } else {
                nickErrorText.style.opacity = 1;
            }
        }
    });

    // Initialize the collected SaaS list
    // updateCollectedSaasList();

    initializeClouds();

    var fullSaasListButton = document.getElementById('fullSaasListButton');
    fullSaasListButton.onclick = function () {
        window.location.href = 'saaslist.html';
    };
});

function drawBackground() {
    if (global.ctx && global.backgroundImage) {
        global.ctx.drawImage(global.backgroundImage, 0, 0, global.screen.width, global.screen.height);
    }
}


function updateCollectedSaas() {
    const collectedSaasElement = document.getElementById('collectedSaas');
    let listHTML = '<span class="title">Collected SaaS</span>';
    
    player.collectedSaas.forEach((saasName) => {
        const saasInfo = saasInfoCollection.find(saas => saas.saasname === saasName);
        if (saasInfo) {
            listHTML += `<div class="collected-saas-item" data-saas-id="${saasInfo.id}">${saasName}</div>`;
        }
    });
    
    collectedSaasElement.innerHTML = listHTML;
    collectedSaasElement.querySelectorAll('.collected-saas-item').forEach(item => {
        item.addEventListener('click', () => {
            const saasId = parseInt(item.getAttribute('data-saas-id'), 10);
            const saasInfo = saasInfoCollection.find(saas => saas.id === saasId);
            if (saasInfo) {
                showSaasPopup(saasInfo);
            }
        });
    });
}

// Add this function to handle clicks on collected SaaS items
function showSaasPopupFromList(saasId) {
    const saasInfo = saasInfoCollection.find(saas => saas.id === saasId);
    if (saasInfo) {
        console.log("Showing popup for:", saasInfo);
        showSaasPopup(saasInfo);
    } else {
        console.error("SaaS info not found for id:", saasId);
    }
}

// Make sure this function is accessible globally
window.showSaasPopupFromList = showSaasPopupFromList;


var playerConfig = {
    border: 6,
    textColor: '#FFFFFF',
    textBorder: '#000000',
    textBorderSize: 3,
    defaultSize: 30
};

var player = {
    id: -1,
    x: global.screen.width / 2,
    y: global.screen.height / 2,
    screenWidth: global.screen.width,
    screenHeight: global.screen.height,
    target: { x: global.screen.width / 2, y: global.screen.height / 2 }
};

global.player = player;


window.canvas = new Canvas();

// var visibleBorderSetting = document.getElementById('visBord');
// visibleBorderSetting.onchange = settings.toggleBorder;

// var showMassSetting = document.getElementById('showMass');
// showMassSetting.onchange = settings.toggleMass;

// var continuitySetting = document.getElementById('continuity');
// continuitySetting.onchange = settings.toggleContinuity;

// var roundFoodSetting = document.getElementById('roundFood');
// roundFoodSetting.onchange = settings.toggleRoundFood;

var c = window.canvas.cv;
var graph = c.getContext('2d');

// $("#feed").click(function () {
//     if (player && player.feed) {
//         const ejectedFood = player.feed();
//         if (ejectedFood) {
//             gameState.food.push(ejectedFood);
//         }
//     }
// });

// $("#split").click(function () {
//     if (player && player.split) {
//         player.split();
//     }
// });

const isUnnamedCell = (name) => name.length < 1;


const getPosition = (entity, player, screen) => {
    return {
        x: entity.x - player.x + screen.width / 2,
        y: entity.y - player.y + screen.height / 2
    }
}

window.requestAnimFrame = (function () {
    return window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (callback) {
            window.setTimeout(callback, 1000 / 60);
        };
})();

window.cancelAnimFrame = (function (handle) {
    return window.cancelAnimationFrame ||
        window.mozCancelAnimationFrame;
})();

function balanceObjects() {
    // Respawn food
    while (gameState.food.length < config.maxFood) {
        gameState.food.push(new Food());
    }

    // Respawn viruses
    while (gameState.viruses.length < config.maxVirus) {
        gameState.viruses.push(new Virus());
    }

    // SaaS blobs are not respawned
}

function updateScore() {
    const scoreElement = document.getElementById('playerScore');
    if (scoreElement && player) {
        scoreElement.textContent = Math.floor(player.score);
    }
}


// Make sure these are defined in the global scope
window.showSaasPopupFromList = showSaasPopupFromList;
window.showSaasPopup = showSaasPopup;

// Add this after the window.onload function
global.clouds = render.createClouds(global.screen, 25);


// This function is called from index.html
window.startGame = startGame;

// Initialize game state
gameState = {
    players: [],
    food: [],
    viruses: [],
    saasBlobs: []
};

var foods = [];
var viruses = [];
var fireFood = [];
var users = [];
var leaderboard = [];
var saasBlobs = []; // Add this line
var target = { x: player.x, y: player.y };
global.target = target;



const saasInfoCollection = [
    {
        id: 1,
        saasname: "Complete SEO Manager",
        description: "Manage, simplify, and master SEO all in one system.",
        websiteurl: "https://seoperate.com/complete-seo-manager/",
        name: "Matt",
        x: "https://x.com/matt_npl",
        discount: "40%",
        discountcode: "I3NJIYMG",
        size: 450 // Add this line
    },
    {
        id: 2,
        saasname: "Bullist",
        description: "Quick & easy list graphics for social media.",
        websiteurl: "https://bullist.so",
        name: "Matt",
        x: "https://twitter.com/matt_npl",
        discount: "",
        discountcode: "",
        size: 120 // Add this line
    },
    {
        id: 3,
        saasname: "NichePlates",
        description: "Notion & Framer Templates Marketplace.",
        websiteurl: "https://www.nicheplates.com/",
        name: "Matt",
        x: "https://twitter.com/matt_npl",
        discount: "",
        discountcode: "",
        size: 150 // Add this line
    },
    // Add more SaaS info objects as needed, including the size property
];


// Export necessary functions for external use if needed
export { startGame, getVirusGif, saasInfoCollection, getRandomSaasInfo, getSaasInfoById};

// Function to get a random SaaS info
function getRandomSaasInfo() {
    return saasInfoCollection[Math.floor(Math.random() * saasInfoCollection.length)];
}

// Function to get SaaS info by ID
function getSaasInfoById(id) {
    return saasInfoCollection.find(info => info.id === id);
}

// // You can now use these functions in your game logic, for example:
// function handleSaasCollision(saasBlob) {
//     const saasInfo = getRandomSaasInfo();
//     showSaasPopup(saasInfo);
// }

function getVirusGif() {
    return global.virusGif;
}

// Use parseGIF and decompressFrames in an async function
async function initGifuct() {
    if (typeof parseGIF === 'function' && typeof decompressFrames === 'function') {
        // Your code that uses parseGIF and decompressFrames
    } else {
        setTimeout(initGifuct, 100); // Try again in 100ms
    }
}

initGifuct();

// Replace synchronous calls with async calls
async function processGif(arrayBuffer) {
  const gif = await parseGIF(arrayBuffer);
  const frames = await decompressFrames(gif);
  // Rest of your code...
}
// Make sure to call processGif instead of directly calling parseGIF and decompressFrames

document.addEventListener('DOMContentLoaded', function() {
    const imgElement = document.getElementById('yourImageId');
    if (imgElement) {
        imgElement.onerror = function() {
            // Your error handling code
        };
    }
});

// Add this function after the updateScore function

function gameCompleted() {
    global.gameStart = false;
    const gameAreaWrapper = document.getElementById('gameAreaWrapper');
    const completionMessage = document.createElement('div');
    completionMessage.id = 'completionMessage';
    completionMessage.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: rgba(0, 0, 0, 0.9);
        color: white;
        padding: ${global.isMobile ? '20px' : '40px'};
        border-radius: 20px;
        box-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
        z-index: 2000;
        text-align: center;
        font-family: Arial, sans-serif;
        max-width: 80%;
        width: ${global.isMobile ? '90%' : '500px'};
    `;

    const elapsedTime = Math.floor((Date.now() - player.gameStartTime) / 1000);
    const minutes = Math.floor(elapsedTime / 60);
    const seconds = elapsedTime % 60;

    completionMessage.innerHTML = `
        <h2 style="color: #4CAF50; font-size: 28px; margin-bottom: 20px;">Congratulations!</h2>
        <p style="font-size: 18px; margin-bottom: 20px;">You've caught all the SaaS products in ${minutes} minutes and ${seconds} seconds!</p>
        <h3 style="color: #3498db; font-size: 22px; margin-bottom: 15px;">Collected SaaS Products:</h3>
        <ul style="list-style-type: none; padding: 0; margin-bottom: 30px;">
            ${player.collectedSaas.map(saas => `<li style="font-size: 16px; margin-bottom: 5px;">${saas}</li>`).join('')}
        </ul>
        <button id="backToStartButton" style="
            background-color: #3498db;
            color: white;
            border: none;
            padding: 15px 30px;
            font-size: 18px;
            cursor: pointer;
            border-radius: 5px;
            transition: background-color 0.3s ease;
        ">Back to Start Screen</button>
    `;

    gameAreaWrapper.appendChild(completionMessage);

    const backToStartButton = document.getElementById('backToStartButton');
    backToStartButton.addEventListener('mouseover', () => {
        backToStartButton.style.backgroundColor = '#2980b9';
    });
    backToStartButton.addEventListener('mouseout', () => {
        backToStartButton.style.backgroundColor = '#3498db';
    });
    backToStartButton.addEventListener('click', () => {
        window.location.reload();
    });
}

function resetGame() {
    // Remove the completion message
    const completionMessage = document.getElementById('completionMessage');
    if (completionMessage) {
        completionMessage.remove();
    }

    // Reset game state
    gameState = {
        players: [],
        food: [],
        viruses: [],
        saasBlobs: []
    };

    // Reset player
    player = null;

    // Clear the canvas
    const canvas = document.getElementById('cvs');
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Hide game area and show start menu
    document.getElementById('gameAreaWrapper').style.display = 'none';
    document.getElementById('startMenuWrapper').style.display = 'flex';

    // Reset other necessary variables
    global.gameStart = false;
    gameStarted = false;
    collectedSaas = [];

    // Reset the player name input
    document.getElementById('playerNameInput').value = '';
}

// Initialize powerups array
gameState.powerups = []

// Function to spawn powerups
function spawnPowerup() {
    if (Math.random() < 0.01 && gameState.powerups.length < 5) { // 1% chance each frame, max 5 powerups
        gameState.powerups.push(new Powerup());
    }
}

// Add powerup collision detection
function checkPowerupCollisions() {
    if (!gameState.powerups) {
        gameState.powerups = []; // Initialize if undefined
        return;
    }

    gameState.powerups = gameState.powerups.filter((powerup, index) => {
        const dx = player.x - powerup.x;
        const dy = player.y - powerup.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        if (distance < player.radius + powerup.radius) {
            player.applySpeedBoost(powerup); // Pass the powerup object
            return false; // Remove the powerup
        }
        return true;
    });
}

// Activate the powerup
function activatePowerup(powerup) {
    player.speedBoost = powerup.speedBoost;

    setTimeout(() => {
        player.speedBoost = 1; // Reset to normal speed
    }, powerup.duration);
}

function displayCollectedSaas() {
    const collectedSaasElement = document.getElementById('collectedSaas');
    collectedSaasElement.innerHTML = '<span class="title">Collected SaaS</span>';
    
    collectedSaas.forEach(saasName => {
        const saasItem = document.createElement('span');
        saasItem.className = 'collected-saas-item';
        saasItem.textContent = saasName;
        saasItem.style.pointerEvents = 'auto'; // Add this line
        collectedSaasElement.appendChild(saasItem);
    });

    collectedSaasElement.querySelectorAll('.collected-saas-item').forEach(item => {
        item.addEventListener('click', (event) => {
            event.stopPropagation(); // Add this line
            const saasInfo = saasInfoCollection.find(saas => saas.saasname === item.textContent.trim());
            if (saasInfo) {
                showSaasPopup(saasInfo);
            }
        });
    });
}

function addCollectedSaas(saas) {
    const collectedSaasList = document.getElementById('collectedSaasList');
    if (!collectedSaasList) return;

    const listItem = document.createElement('li');
    listItem.className = 'collected-saas-item';
    listItem.textContent = saas.saasname;
    listItem.onclick = () => showSaasPopupFromList(saas);
    collectedSaasList.appendChild(listItem);
}

// Add these functions at the end of the file

function updateLevelInfo() {
    const levelElement = document.getElementById('playerLevel');
    if (levelElement && player) {
        levelElement.textContent = player.level;
    }
}

function updateTimer() {
    const timerElement = document.getElementById('gameTimer');
    if (timerElement && player) {
        const elapsedTime = (Date.now() - player.gameStartTime) / 1000;
        const minutes = Math.floor(elapsedTime / 60);
        const seconds = Math.floor(elapsedTime % 60);
        const deciseconds = Math.floor((elapsedTime % 1) * 10);
        timerElement.textContent = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}.${deciseconds}`;
    }
}

function allUniqueSaasCollected() {
    const uniqueSaasNames = new Set(saasInfoCollection.map(saas => saas.saasname));
    const collectedSaasNames = new Set(collectedSaas);
    return uniqueSaasNames.size === collectedSaasNames.size;
}

// initializeLevel(player.level);

function checkFoodCollisions() {
    gameState.food = gameState.food.filter((food, index) => {
        const dx = player.x - food.x;
        const dy = player.y - food.y;
        const distance = Math.sqrt(dx * dx + dy * dy);

        // Check if the player cloud fully overlaps the food cloud
        if (distance + food.radius <= player.radius) {
            player.eatFood(food);
            return false; // Remove the food
        }
        return true;
    });
}